import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ThemeSegmented } from './ThemeToggle';
import SettingsMenu from './SettingsMenu';
import {
  Search, Menu, X, ChevronDown,
  BookOpen, Target, Users, Award, Music, GraduationCap,
  BookMarked, Calendar, DollarSign, BarChart2,
  Building2, Newspaper, ImageIcon, Clock, Download, Star,
  Monitor, Mail, Link2, FileText, Library, Shield, ShieldCheck, Info,
  Briefcase, FlaskConical, Heart, Cpu, ExternalLink, Archive, Cloud, Megaphone, UsersRound
} from 'lucide-react';

const LOGO_URL = 'https://storage.stikes-hi.ac.id/stikes-hi-media/3fbebd76-22d3-4641-a12f-ec3c51280150.png';

const navData = [
  { label: 'BERANDA', path: '/' },
  {
    label: 'TENTANG KAMI',
    dropdown: [
      { section: 'Profil Institusi' },
      { label: 'Sejarah Kampus', path: '/sejarah', icon: <BookOpen size={15} /> },
      { label: 'Visi & Misi', path: '/visi-misi', icon: <Target size={15} /> },
      { label: 'Struktur Organisasi', path: '/struktur-organisasi', icon: <Users size={15} /> },
      { label: 'Dosen & Tendik', path: '/dosen-tendik', icon: <GraduationCap size={15} /> },
      { label: 'Sarana & Prasarana', path: '/sarana-prasarana', icon: <Building2 size={15} /> },
      { label: 'Logo Kampus', path: '/logo', icon: <Award size={15} /> },
      { label: 'Mars / Hymne STIKES HI', path: '/mars-stikes', icon: <Music size={15} /> },
      { section: 'Unit & Lembaga', columns: 2, alignRowsWithFirst: true },
      { label: 'BAAK', path: '/unit/baak', icon: <BookMarked size={15} /> },
      { label: 'BAK', path: '/unit/bak', icon: <Briefcase size={15} /> },
      { label: 'BAUK', path: '/unit/bauk', icon: <Building2 size={15} /> },
      { label: 'Humas', path: '/unit/humas', icon: <Megaphone size={15} /> },
      { label: 'Unit IT', path: '/unit/it', icon: <Cpu size={15} /> },
      { label: 'Kemahasiswaan & Alumni', path: '/unit/kemahasiswaan', icon: <UsersRound size={15} /> },
      { label: 'Pusat Karir', path: '/unit/pusat-karir', icon: <Heart size={15} /> },
      { label: 'LPM', url: 'http://lpm.stikes-hi.ac.id/', icon: <Shield size={15} />, ext: true },
      { label: 'P3M', url: 'http://pppm.stikes-hi.ac.id/', icon: <FlaskConical size={15} />, ext: true },
      { label: 'Perpustakaan', url: 'http://perpus.stikes-hi.ac.id/', icon: <Library size={15} />, ext: true },
    ]
  },
  {
    label: 'AKADEMIK',
    dropdown: [
      { label: 'Program Studi', path: '/program-studi', icon: <BookMarked size={15} /> },
      { label: 'Kalender Akademik', path: '/kalender', icon: <Calendar size={15} /> },
      { label: 'Beasiswa', path: '/beasiswa', icon: <DollarSign size={15} /> },
      { label: 'Tracer Study', path: '/tracer-study', icon: <BarChart2 size={15} /> },
      { label: 'UKM', path: '/ukm', icon: <Star size={15} /> },
      { label: 'Prestasi Mahasiswa', path: '/prestasi-mahasiswa', icon: <Award size={15} /> },
      { label: 'SPMI BASOK', url: 'https://spmi-basok.stikes-hi.ac.id/', icon: <ShieldCheck size={15} />, ext: true },
    ]
  },
  {
    label: 'INFORMASI',
    dropdown: [
      { label: 'Berita & Pengumuman', path: '/berita', icon: <Newspaper size={15} /> },
      { label: 'Agenda / Event', path: '/agenda', icon: <Clock size={15} /> },
      { label: 'Galeri Foto & Video', path: '/galeri', icon: <ImageIcon size={15} /> },
      { label: 'Download File', path: '/download', icon: <Download size={15} /> },
      { label: 'Hi News', url: 'http://hinews.stikes-hi.ac.id', icon: <Newspaper size={15} />, ext: true },
    ]
  },
  {
    label: 'PORTAL',
    dropdown: [
      { section: 'Akademik' },
      { label: 'Portal Mahasiswa', url: 'http://mhs.stikes-hi.ac.id/', icon: <Users size={15} />, ext: true },
      { label: 'Portal Orang Tua', url: 'https://ortu.stikes-hi.ac.id/', icon: <Users size={15} />, ext: true },
      { label: 'Portal Dosen', url: 'https://dosen.stikes-hi.ac.id/', icon: <GraduationCap size={15} />, ext: true },
      { label: 'E-Learning', url: 'http://elearning.stikes-hi.ac.id/', icon: <Monitor size={15} />, ext: true },
      { label: 'Jurnal', url: 'http://jurnal.stikes-hi.ac.id/', icon: <BookOpen size={15} />, ext: true },
      { label: 'Repository Eprints', url: 'http://eprints.stikes-hi.ac.id/', icon: <Archive size={15} />, ext: true },
      { label: 'E-Catalog Perpustakaan', url: 'https://ecatalog.stikes-hi.ac.id/', icon: <Library size={15} />, ext: true },

      { section: 'Layanan' },
      { label: 'Webmail', url: 'http://webmail.stikes-hi.ac.id/', icon: <Mail size={15} />, ext: true },
      { label: 'Outlook Email', url: 'https://outlook.office.com/mail/login', icon: <Mail size={15} />, ext: true },
      { label: 'OneDrive', url: 'https://onedrive.live.com/login/en-us/', icon: <Cloud size={15} />, ext: true },
      { label: 'Formulir', url: 'https://form.stikes-hi.ac.id', icon: <FileText size={15} />, ext: true },
      { label: 'Short URL', url: 'https://s.stikes-hi.ac.id/', icon: <Link2 size={15} />, ext: true },
      { label: 'PPKPT', url: 'https://ppkpt.stikes-hi.ac.id/', icon: <Shield size={15} />, ext: true },
      { label: 'PPID', url: 'https://ppid.stikes-hi.ac.id/', icon: <Info size={15} />, ext: true },
    ]
  },
  { label: 'KONTAK', path: '/kontak' },
];

// ── SEARCH MODAL ──────────────────────────────────────────────────────────────
const ALL_PAGES = [
  { label: 'Beranda', path: '/', keywords: 'beranda home utama' },
  { label: 'Sejarah Kampus', path: '/sejarah', keywords: 'sejarah history kampus berdiri' },
  { label: 'Visi & Misi', path: '/visi-misi', keywords: 'visi misi tujuan sasaran' },
  { label: 'Struktur Organisasi', path: '/struktur-organisasi', keywords: 'struktur organisasi jabatan pimpinan' },
  { label: 'Logo Kampus', path: '/logo', keywords: 'logo lambang identitas' },
  { label: 'Mars / Hymne STIKES HI', path: '/mars-stikes', keywords: 'mars hymne lagu' },
  { label: 'Dosen & Tenaga Kependidikan', path: '/dosen-tendik', keywords: 'dosen tendik pengajar staff nidn nuptk' },
  { label: 'BAAK', path: '/unit/baak', keywords: 'baak biro administrasi akademik kemahasiswaan jadwal kuliah krs nilai transkrip unit lembaga pengumuman' },
  { label: 'BAK', path: '/unit/bak', keywords: 'bak biro administrasi keuangan pembayaran verifikasi pembayaran spp her-registrasi unit lembaga pengumuman' },
  { label: 'BAUK', path: '/unit/bauk', keywords: 'bauk biro administrasi umum kepegawaian perlengkapan unit lembaga pengumuman' },
  { label: 'Humas', path: '/unit/humas', keywords: 'humas hubungan masyarakat kerjasama ppid informasi publik unit lembaga' },
  { label: 'Unit IT', path: '/unit/it', keywords: 'unit it teknologi informasi sistem informasi jaringan internet layanan teknis portal bantuan digital' },
  { label: 'Kemahasiswaan & Alumni', path: '/unit/kemahasiswaan', keywords: 'kemahasiswaan alumni organisasi mahasiswa bem hmps ukm pkm penalaran minat bakat prestasi lomba beasiswa konseling kegiatan mahasiswa ikatan alumni pembinaan karakter unit lembaga' },
  { label: 'Prestasi Mahasiswa', path: '/prestasi-mahasiswa', keywords: 'prestasi mahasiswa penghargaan lomba kompetisi pkm pimnas pilmapres gemastik peksiminas aug penalaran inovasi seni budaya kepemimpinan' },
  { label: 'Pusat Karir & Tracer Study', path: '/unit/pusat-karir', keywords: 'pusat karir career center lowongan kerja magang tracer study alumni bimbingan konseling karir job fair rekrutmen kampus dudi kemitraan industri unit lembaga' },
  { label: 'Program Studi', path: '/program-studi', keywords: 'prodi program studi kesmas keperawatan farmasi ners' },
  { label: 'Kalender Akademik', path: '/kalender', keywords: 'kalender akademik jadwal semester' },
  { label: 'Beasiswa', path: '/beasiswa', keywords: 'beasiswa bantuan biaya kuliah' },
  { label: 'Tracer Study', path: '/tracer-study', keywords: 'tracer study alumni lulusan' },
  { label: 'Sarana & Prasarana', path: '/sarana-prasarana', keywords: 'sarana prasarana fasilitas gedung lab' },
  { label: 'Berita & Pengumuman', path: '/berita', keywords: 'berita pengumuman news info wisuda' },
  { label: 'Galeri Foto & Video', path: '/galeri', keywords: 'galeri foto video dokumentasi' },
  { label: 'Agenda / Event', path: '/agenda', keywords: 'agenda event kegiatan acara seminar wisuda' },
  { label: 'Download File', path: '/download', keywords: 'download file dokumen formulir' },
  { label: 'UKM', path: '/ukm', keywords: 'ukm unit kegiatan mahasiswa ekstrakurikuler' },
  { label: 'Kontak', path: '/kontak', keywords: 'kontak alamat telepon email hubungi lokasi' },
];

const SearchModal = ({ onClose }) => {
  const [query, setQuery] = useState('');
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    inputRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const results = query.trim().length >= 2
    ? ALL_PAGES.filter(p =>
      p.label.toLowerCase().includes(query.toLowerCase()) ||
      p.keywords.toLowerCase().includes(query.toLowerCase())
    )
    : [];

  const handleSelect = (path) => { navigate(path); onClose(); };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim().length >= 2) {
      navigate(`/search?q=${encodeURIComponent(query.trim())}`);
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-start justify-center pt-20 px-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}
      onClick={onClose}
    >
      <div className="w-full max-w-xl bg-white dark:bg-[#1A182E] rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()}>
        <form onSubmit={handleSubmit} className="flex items-center gap-3 px-4 py-4 border-b border-gray-100 dark:border-gray-800">
          <Search size={20} className="text-purple-500 flex-shrink-0" />
          <input
            ref={inputRef}
            type="text"
            placeholder="Cari halaman, dosen, informasi..."
            value={query}
            onChange={e => setQuery(e.target.value)}
            className="flex-1 bg-transparent text-gray-800 dark:text-white placeholder-gray-400 outline-none text-base"
          />
          <button type="submit" className="text-purple-500 hover:text-purple-700 text-xs font-medium px-2">Cari</button>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"><X size={18} /></button>
        </form>
        <div className="max-h-80 overflow-y-auto">
          {query.trim().length < 2 ? (
            <div className="px-4 py-6 text-center text-sm text-gray-400">Ketik minimal 2 karakter untuk mencari...</div>
          ) : results.length === 0 ? (
            <div className="px-4 py-6 text-center text-sm text-gray-400">
              Tidak ada hasil untuk "<span className="font-medium text-gray-600 dark:text-gray-300">{query}</span>"
            </div>
          ) : (
            <div className="py-2">
              {results.map((item) => (
                <button key={item.path} onClick={() => handleSelect(item.path)}
                  className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-purple-50 dark:hover:bg-purple-900/20 transition-all group">
                  <div className="w-8 h-8 rounded-lg bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center flex-shrink-0">
                    <Search size={14} className="text-purple-600 dark:text-purple-400" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-800 dark:text-white group-hover:text-purple-700 dark:group-hover:text-purple-300">{item.label}</div>
                    <div className="text-xs text-gray-400 dark:text-gray-500">stikes-hi.ac.id{item.path}</div>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="px-4 py-2 border-t border-gray-100 dark:border-gray-800 flex items-center gap-4 text-xs text-gray-400">
          <span>↵ untuk mencari</span>
          <span>ESC untuk menutup</span>
        </div>
      </div>
    </div>
  );
};

// ── DROPDOWN PANEL ────────────────────────────────────────────────────────────
const DropdownPanel = ({ items }) => {
  const hasSections = items.some(item => item.section);

  const renderItem = (item, i) => {
    if (item.section) return (
      <div key={i} className="px-4 pt-4 pb-2">
        <span className="text-[10px] font-bold text-purple-400 uppercase tracking-widest">{item.section}</span>
      </div>
    );
    if (item.ext) return (
      <a key={i} href={item.url} target="_blank" rel="noopener noreferrer"
        className="flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-gray-700 dark:text-gray-200
          hover:bg-purple-50 dark:hover:bg-purple-900/20 hover:text-[#7B2FBE] dark:hover:text-[#9333EA]
          transition-all border-l-2 border-transparent hover:border-[#7B2FBE] group">
        <div className="flex items-center gap-3">
          <span className="text-[#7B2FBE] dark:text-[#9333EA]">{item.icon}</span>
          {item.label}
        </div>
        <ExternalLink size={11} className="opacity-40 group-hover:opacity-70 flex-shrink-0" />
      </a>
    );
    return (
      <Link key={i} to={item.path}
        className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 dark:text-gray-200
          hover:bg-purple-50 dark:hover:bg-purple-900/20 hover:text-[#7B2FBE] dark:hover:text-[#9333EA]
          transition-all border-l-2 border-transparent hover:border-[#7B2FBE]">
        <span className="text-[#7B2FBE] dark:text-[#9333EA]">{item.icon}</span>
        {item.label}
      </Link>
    );
  };

  if (!hasSections) {
    return (
      <div className="absolute top-full left-0 mt-2 w-72 rounded-2xl shadow-xl overflow-hidden z-50
        bg-white/95 dark:bg-[#1A182E]/95 backdrop-blur-xl py-2
        border border-purple-100 dark:border-purple-900/30 max-h-[80vh] overflow-y-auto">
        {items.map(renderItem)}
      </div>
    );
  }

  const columns = [];
  let currentCol = [];
  items.forEach(item => {
    if (item.section) {
      if (currentCol.length > 0) columns.push(currentCol);
      currentCol = [item];
    } else {
      currentCol.push(item);
    }
  });
  if (currentCol.length > 0) columns.push(currentCol);
  const referenceRowCount = columns[0]?.filter(item => !item.section).length || 1;

  return (
    <div className="absolute top-full left-0 mt-2 rounded-2xl shadow-xl overflow-hidden z-50
      bg-white/95 dark:bg-[#1A182E]/95 backdrop-blur-xl py-2 px-1
      border border-purple-100 dark:border-purple-900/30 max-h-[80vh] overflow-y-auto">
      <div className="flex gap-1 min-w-max">
        {columns.map((col, cIdx) => {
          const section = col[0]?.section ? col[0] : null;
          const contentItems = section ? col.slice(1) : col;
          const sectionRows = section?.alignRowsWithFirst ? referenceRowCount : section?.rows;
          const sectionColumns = sectionRows
            ? Math.max(section?.columns || 1, Math.ceil(contentItems.length / sectionRows))
            : section?.columns || 1;

          return (
            <div
              key={cIdx}
              className={`${sectionColumns > 1 ? '' : 'w-[260px]'} flex flex-col relative`}
              style={sectionColumns > 1 ? { width: `${sectionColumns * 220}px` } : undefined}
            >
              {cIdx > 0 && <div className="absolute left-[-2px] top-6 bottom-4 w-px bg-gray-100 dark:bg-gray-800"></div>}
              {section && renderItem(section, `section-${cIdx}`)}
              <div
                className={sectionColumns > 1 ? 'grid gap-x-1' : ''}
                style={sectionRows ? {
                  gridAutoFlow: 'column',
                  gridTemplateRows: `repeat(${sectionRows}, minmax(0, auto))`,
                  gridTemplateColumns: `repeat(${sectionColumns}, minmax(0, 1fr))`,
                } : undefined}
              >
                {contentItems.map((item, i) => renderItem(item, `col-${cIdx}-${i}`))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ── NAVBAR ────────────────────────────────────────────────────────────────────
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [openMobileMenus, setOpenMobileMenus] = useState({});
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const hoverTimerRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setActiveDropdown(null);
    setOpenMobileMenus({});
  }, [location]);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') { e.preventDefault(); setSearchOpen(true); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const isTransparent = isHome && !scrolled;

  const navbarClass = `fixed top-0 left-0 right-0 z-50 h-[70px] transition-all duration-300 ${isTransparent
    ? 'bg-transparent'
    : 'bg-white/85 dark:bg-[#121020]/85 backdrop-blur-xl border-b border-purple-100/50 dark:border-purple-900/20 shadow-sm'
    }`;

  const textClass = isTransparent ? 'text-white' : 'text-[#1A1A2E] dark:text-gray-100';
  const iconClass = isTransparent ? 'text-white hover:bg-white/15' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800/60';

  const onMouseEnter = (label) => { clearTimeout(hoverTimerRef.current); setActiveDropdown(label); };
  const onMouseLeave = () => { hoverTimerRef.current = setTimeout(() => setActiveDropdown(null), 150); };
  const toggleMobileAccordion = (label) => setOpenMobileMenus(prev => ({ ...prev, [label]: !prev[label] }));

  return (
    <>
      {searchOpen && <SearchModal onClose={() => setSearchOpen(false)} />}
      <nav className={navbarClass} data-testid="navbar">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 flex-shrink-0" data-testid="navbar-logo">
            <img src={LOGO_URL} alt="Logo STIKES HI Jambi" className="h-10 w-10 object-contain" />
            <div>
              <div className={`font-bold text-base leading-tight font-heading ${textClass}`}>STIKES HI</div>
              <div className={`text-xs leading-tight ${isTransparent ? 'text-white/75' : 'text-gray-500 dark:text-gray-400'}`}>Harapan Ibu Jambi</div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-0.5">
            {navData.map((item) => (
              <div key={item.label} className="relative"
                onMouseEnter={() => item.dropdown && onMouseEnter(item.label)}
                onMouseLeave={onMouseLeave}>
                {item.path ? (
                  <Link to={item.path}
                    className={`flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${location.pathname === item.path
                      ? 'text-[#7B2FBE] dark:text-[#9333EA] bg-purple-50 dark:bg-purple-900/20'
                      : `${textClass} hover:text-[#7B2FBE] dark:hover:text-[#9333EA] hover:bg-purple-50/80 dark:hover:bg-purple-900/15`
                      }`}>
                    {item.label}
                  </Link>
                ) : (
                  <button className={`flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${activeDropdown === item.label
                    ? 'text-[#7B2FBE] dark:text-[#9333EA] bg-purple-50 dark:bg-purple-900/20'
                    : `${textClass} hover:text-[#7B2FBE] dark:hover:text-[#9333EA] hover:bg-purple-50/80 dark:hover:bg-purple-900/15`
                    }`}>
                    {item.label}
                    <ChevronDown size={13} className={`transition-transform duration-200 ${activeDropdown === item.label ? 'rotate-180' : ''}`} />
                  </button>
                )}
                {item.dropdown && activeDropdown === item.label && <DropdownPanel items={item.dropdown} />}
              </div>
            ))}
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-1.5">
            {/* Tombol PPKPT — layanan pengaduan kekerasan seksual, sengaja dibuat
                lebih tenang dari tombol PMB supaya tidak berebut perhatian,
                tapi tetap mudah ditemukan di header utama. */}
            <a href="https://ppkpt.stikes-hi.ac.id" target="_blank" rel="noopener noreferrer"
              title="PPKPT — Layanan Pengaduan Kekerasan Seksual"
              className={`hidden sm:flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold border transition-all duration-200
                ${isTransparent
                  ? 'border-white/35 text-white hover:bg-white/10'
                  : 'border-emerald-200 dark:border-emerald-800/50 text-emerald-700 dark:text-emerald-300 hover:bg-emerald-50 dark:hover:bg-emerald-900/20'}`}>
              <ShieldCheck size={14} />
              <span className="hidden 2xl:inline">PPKPT</span>
            </a>

            {/* Tombol PPID — layanan informasi & dokumentasi publik, gaya
                sama seperti PPKPT supaya keduanya terasa satu kelompok
                "layanan resmi" dan tidak menyaingi tombol PMB. */}
            <a href="https://ppid.stikes-hi.ac.id" target="_blank" rel="noopener noreferrer"
              title="PPID — Layanan Informasi & Dokumentasi Publik"
              className={`hidden sm:flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold border transition-all duration-200
                ${isTransparent
                  ? 'border-white/35 text-white hover:bg-white/10'
                  : 'border-sky-200 dark:border-sky-800/50 text-sky-700 dark:text-sky-300 hover:bg-sky-50 dark:hover:bg-sky-900/20'}`}>
              <Info size={14} />
              <span className="hidden 2xl:inline">PPID</span>
            </a>

            {/* Tombol PMB */}
            <a href="https://pmb.stikes-hi.ac.id" target="_blank" rel="noopener noreferrer"
              className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-all duration-200
                bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600
                text-white shadow-md shadow-orange-500/30 hover:shadow-orange-500/50 hover:scale-105">
              🎓 <span className="hidden 2xl:inline">DAFTAR&nbsp;</span>PMB
            </a>

            <button data-testid="search-btn" onClick={() => setSearchOpen(true)}
              className={`p-2 rounded-full transition-all ${iconClass}`} aria-label="Cari">
              <Search size={17} />
            </button>
            <SettingsMenu iconClass={iconClass} />
            <button data-testid="mobile-menu-btn" onClick={() => setMobileOpen(!mobileOpen)}
              className={`lg:hidden p-2 rounded-full transition-all ${iconClass}`}>
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {/* Mobile Drawer */}
        {mobileOpen && (
          <div className="lg:hidden absolute top-[70px] left-0 right-0 bg-white dark:bg-[#121020]
            border-t border-gray-100 dark:border-gray-800 shadow-2xl max-h-[80vh] overflow-y-auto">
            <div className="px-4 py-4 space-y-1">
              {/* PMB mobile */}
              <a href="https://pmb.stikes-hi.ac.id" target="_blank" rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-bold
                  bg-gradient-to-r from-orange-500 to-amber-500 text-white mb-2">
                🎓 DAFTAR PMB
              </a>
              {/* PPKPT mobile */}
              <a href="https://ppkpt.stikes-hi.ac.id" target="_blank" rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-semibold
                  border border-emerald-200 dark:border-emerald-800/50 text-emerald-700 dark:text-emerald-300 mb-2">
                <ShieldCheck size={16} /> PPKPT — Layanan Pengaduan
              </a>
              {/* PPID mobile */}
              <a href="https://ppid.stikes-hi.ac.id" target="_blank" rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-semibold
                  border border-sky-200 dark:border-sky-800/50 text-sky-700 dark:text-sky-300 mb-2">
                <Info size={16} /> PPID — Informasi & Dokumentasi
              </a>
              {/* Search mobile */}
              <button onClick={() => { setSearchOpen(true); setMobileOpen(false); }}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium
                  text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800/60 transition-all">
                <Search size={15} className="text-purple-500" /> Cari halaman...
              </button>

              {/* Pilihan tema mobile */}
              <div className="px-1 pt-1 pb-2">
                <p className="px-3 pb-1.5 text-[10px] font-bold uppercase tracking-widest text-gray-400 dark:text-gray-500">
                  Tampilan
                </p>
                <ThemeSegmented />
              </div>

              {navData.map((item) => (
                <div key={item.label}>
                  {item.path ? (
                    <Link to={item.path}
                      className={`block px-4 py-3 rounded-xl text-sm font-medium transition-all ${location.pathname === item.path
                        ? 'bg-purple-50 dark:bg-purple-900/20 text-[#7B2FBE] dark:text-[#9333EA]'
                        : 'text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800/60'
                        }`}>
                      {item.label}
                    </Link>
                  ) : (
                    <>
                      <button onClick={() => toggleMobileAccordion(item.label)}
                        className="w-full flex items-center justify-between px-4 py-3 rounded-xl text-sm font-medium
                          text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800/60 transition-all">
                        {item.label}
                        <ChevronDown size={15} className={`transition-transform duration-200 ${openMobileMenus[item.label] ? 'rotate-180' : ''}`} />
                      </button>
                      {openMobileMenus[item.label] && (
                        <div className="ml-4 mt-1 mb-2 border-l-2 border-purple-200 dark:border-purple-800/50 pl-4 space-y-0.5">
                          {item.dropdown.map((sub, i) => {
                            if (sub.section) return (
                              <p key={i} className="text-[10px] font-bold text-purple-400 uppercase tracking-widest pt-2 pb-1">{sub.section}</p>
                            );
                            if (sub.ext) return (
                              <a key={i} href={sub.url} target="_blank" rel="noopener noreferrer"
                                className="flex items-center justify-between gap-2 px-3 py-2.5 text-sm rounded-lg
                                  text-gray-600 dark:text-gray-300 hover:text-[#7B2FBE] dark:hover:text-[#9333EA]
                                  hover:bg-purple-50/50 dark:hover:bg-purple-900/10 transition-all">
                                <div className="flex items-center gap-2">
                                  <span className="text-[#7B2FBE] dark:text-[#9333EA]">{sub.icon}</span>
                                  {sub.label}
                                </div>
                                <ExternalLink size={11} className="opacity-40" />
                              </a>
                            );
                            return (
                              <Link key={i} to={sub.path}
                                className="flex items-center gap-2.5 px-3 py-2.5 text-sm rounded-lg
                                  text-gray-600 dark:text-gray-300 hover:text-[#7B2FBE] dark:hover:text-[#9333EA]
                                  hover:bg-purple-50/50 dark:hover:bg-purple-900/10 transition-all">
                                <span className="text-[#7B2FBE] dark:text-[#9333EA]">{sub.icon}</span>
                                {sub.label}
                              </Link>
                            );
                          })}
                        </div>
                      )}
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
